import BillingPriceMetadata from '@/datatypes/billing/price-metadata';

export default class BillingPriceUpdateRequest {
  public unitAmount: undefined | number = undefined;
  public metadata: BillingPriceMetadata = new BillingPriceMetadata({});
  public active = true;

  constructor(options) {
    if (options.metadata) {
      this.metadata = new BillingPriceMetadata(options.metadata);
    }
    if (options.unitAmount) {
      this.unitAmount = parseInt(options.unitAmount, 10);
    }
    this.active = options.active;
  }
}
